// extracted by mini-css-extract-plugin
export default {"angle":"AngleWindow_angle__18196","angleText":"AngleWindow_angleText__kzHNQ","angleBtn":"AngleWindow_angleBtn__PqiOW","angleBtnNext":"AngleWindow_angleBtnNext__lOFJ7"};